<template>
  <div id="dashboard">
    <template
      v-if="user === 'ppuerta@anglidata.com' || user === 'christian@salsa.pe'">
      <div v-if="initProgress" class="w-100 mt-5 mb-5">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
      <div class="dashboard__header">
        <vx-card collapse="false" ref="filterCard" title="Rango de fechas" class="user-list-filters mb-8"
                 collapse-action
                 @refresh="resetFilters">
          <!--Filter by date-->
          <div class="dashboard__filter">
            <div>
              <datepicker label="Desde" v-model="startDate"
                          id="startDate"
                          v-validate="'required'" name="startDate"></datepicker>
            </div>
            <div>
              <datepicker label="Hasta" v-model="endDate" id="endDate"
                          v-validate="'required'" name="startDate"></datepicker>
            </div>
          </div>
          <div class="vx-col mt-2">
            <vs-button @click="filterByDate" class="mr-6 vs-align-right">Filtrar</vs-button>
          </div>
        </vx-card>
      </div>
      <div class="dashboard__content">
        <div class="dashboard__card">
          <h1>Total de ventas</h1>
          <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(total) }}</span>
        </div>
        <div class="dashboard__card">
          <h1>Total de compras</h1>
          <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(purchasesTotal) }}</span>
        </div>
        <div class="dashboard__card">
          <h1>Total de anulaciones</h1>
          <span>{{ 'S/ ' + Intl.NumberFormat('en-US', {}).format(creditNotesTotal) }}</span>
        </div>
        <div class="dashboard__card">
          <h1>Cantidad de comprobantes</h1>
          <span>{{ Intl.NumberFormat('en-US', {}).format(sales.length) }}</span>
        </div>
        <div class="dashboard__card">
          <h1>Cantidad de productos</h1>
          <span>{{
            Intl.NumberFormat('en-US', {}).format(products.reduce((a, c) => { return a += c.quantity}, 0))
            }} und</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-3/3 mb-base">
          <vx-card title="Ventas">
            <div slot="no-body" class="p-6 pb-0">
              <div class="flex" v-if="revenueGenerated.analyticsData">
                <div class="mr-6">
                  <p class="mb-1 font-semibold">Total</p>
                  <p class="text-3xl text-success"><sup class="text-base mr-1">S/</sup>{{
                    revenueGenerated.analyticsData.total
                    }}</p>
                </div>
              </div>
              <vue-apex-charts
                ref="chart1"
                type="line"
                height="266"
                :options="options"
                :series="series"/>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="dashboard__resume dashboard__resume--one mb-12">
        <div>
          <h2>Ranking de vendedores</h2>
          <vs-table class="mt-5" :data="seller">

            <template slot="thead">
              <vs-th>Nombre</vs-th>
              <vs-th>Total</vs-th>
            </template>

            <template slot-scope=" {data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td>
                  <p>{{ tr.displayName }}</p>
                </vs-td>

                <vs-td :data="tr.total">
                  <p>S/ {{
                    Intl.NumberFormat('en-US', {}).format(tr.total)
                    }}</p>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="dashboard__resume dashboard__resume--one">
        <div>
          <h2>Productos vendidos</h2>
          <vs-table pagination :max-items="10" class="mt-5" :data="products">

            <template slot="thead">
              <vs-th>Nombre</vs-th>
              <vs-th>SKU</vs-th>
              <vs-th>Cantidad</vs-th>
              <vs-th>Precio</vs-th>
            </template>

            <template slot-scope=" {data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="tr.name">
                  <p>{{ tr.description }}</p>
                </vs-td>

                <vs-td :data="tr.sku">
                  <p>{{ tr.sku }}</p>
                </vs-td>

                <vs-td :data="tr.quantity">
                  <p>{{ tr.quantity }}</p>
                </vs-td>

                <vs-td style="                                            width: 15% !important;" :data="tr.price">
                  <p>S/ {{
                    Intl.NumberFormat('en-US', {}).format(tr.price * 1.18)
                    }}</p>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { auth, db, Timestamp } from '@/firebase/firebaseConfig'
import Datepicker from 'vuejs-datepicker'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'Home',
  components: {
    VueApexCharts,
    Datepicker
  },
  computed: {
    user() {
      return auth.currentUser.email
    },
    options() {
      return this.revenueComparisonLine.chartOptions
    },
    series() {
      return this.revenueGenerated.seriesLine
    }
  },
  watch: {
    series() {
      this.$refs.chart1.updateOptions({
        labels: this.options.labels
      })
      this.$refs.chart1.updateSeries([{
        data: this.series[0].data,
      }], false, true)
    }
  },
  data() {
    return {
      sales: [],
      creditNotes: [],
      purchases: [],
      products: [],
      total: 0,
      purchasesTotal: 0,
      creditNotesTotal: 0,
      initProgress: false,
      startDate: null,
      endDate: null,
      seller: [],
      revenueGenerated: {
        series: [],
        seriesLine: [],
        analyticsData: {
          total: 0
        }
      },
      revenueComparisonLine: {
        chartOptions: {
          chart: {
            id: 'realtime',
            type: 'line',
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.10
            }
          },
          stroke: {
            width: [0, 4]
          },
          grid: {
            borderColor: '#e7e7e7'
          },
          colors: ['#020082'],
          dataLabels: {
            enabled: false,
            enabledOnSeries: [1]
          },
          labels: [],
          xaxis: {
            type: 'datetime'
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: 'text-grey fill-current'
              },
              formatter(val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
              }
            }
          },
          tooltip: {
            x: { show: true }
          }
        }
      }
    }
  },
  async created() {
    try {
      if (this.user === 'ppuerta@anglidata.com' || this.user === 'christian@salsa.pe') {
        this.initProgress = true
        await this.loadCurrentSales()
        await this.loadCurrentPurchases()
        await this.generateChartsRevenue()
      }
    } catch (e) {
      console.log(e)
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  methods: {
    /**
     * Load current sales
     * @returns {Promise<void>}
     */
    async loadCurrentSales() {
      this.sales = []
      this.total = 0
      this.products = []
      this.seller = []
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const startTimes = Timestamp.fromDate(
        new Date(year, month, 1, 0, 0, 0, 0)
      )

      const endTimes = Timestamp.fromDate(
        new Date(year, month + 1, 0, 23, 59, 59, 999)
      )

      const querySnapshot = await db.collection('sales')
        .where('status', '==', 'send')
        .where('createdAt', '>=', startTimes)
        .where('createdAt', '<=', endTimes).get()

      querySnapshot.forEach((doc) => {
        if (doc.data().nubefact.invoice.tipo_de_comprobante === 1 || doc.data().nubefact.invoice.tipo_de_comprobante === 3) {
          this.sales.push({
            id: doc.id,
            ...doc.data(),
            createdAt: doc.data().createdAt.toDate()
          })

          // Exchange to PEN
          if (doc.data().currency.code === 'PEN') {
            this.total += doc.data().total
          } else {
            this.total += (doc.data().total * doc.data().exchangeRate)
            console.log(doc.data().total, doc.data().exchangeRate, doc.data().total * doc.data().exchangeRate, doc.data().createdAt.toDate())
          }
          // End

          // Load products
          doc.data().products.forEach((p) => {
            this.products.push({
              ...p
            })
          })

          // Load seller
          const sellerIndex = this.seller.findIndex((s) => s.uid === doc.data().user.uid)
          if (sellerIndex === -1) {
            this.seller.push({
              ...doc.data().user,
              total: (doc.data().currency.code === 'PEN' ? doc.data().total : (doc.data().total * doc.data().exchangeRate))
            })
          } else {
            // Exchange to PEN
            if (doc.data().currency.code === 'PEN') {
              this.seller[sellerIndex].total += doc.data().total
            } else {
              this.seller[sellerIndex].total += (doc.data().total * doc.data().exchangeRate)
            }
          }
        }
      })

      console.log(this.sales)

      this.products.sort((a, b) => {return b.quantity - a.quantity})
      this.seller.sort((a, b) => {return b.total - a.total})
    },
    /**
     * Load Current Credit Notes
     */
    async loadCurrentCreditNotes() {
      this.creditNotes = []

      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const starTimes = Timestamp.fromDate(new Date(year + '/' + (month + 1) + '/1'))
      const endTimes = Timestamp.fromDate(new Date(year + '/' + (month + 1) + '/' + this.$moment(year + '-' + (month + 1), 'YYYY-MM').daysInMonth()))

      const querySnapshot = await db.collection('credits')
        .where('createdAt', '>=', starTimes)
        .where('createdAt', '<=', endTimes).get()

      querySnapshot.forEach((doc) => {
        this.creditNotes.push({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt.toDate()
        })

        // Exchange to PEN
        if (doc.data().currency.code === 'PEN') {
          this.creditNotesTotal -= doc.data().total
        } else {
          this.creditNotesTotal -= (doc.data().total * doc.data().exchangeRate)
        }
        // End
      })
    },
    /**
     * Load current sales
     * @returns {Promise<void>}
     */
    async loadCurrentPurchases() {
      this.purchases = []
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const starTimes = Timestamp.fromDate(new Date(year + '/' + (month + 1) + '/1'))
      const endTimes = Timestamp.fromDate(new Date(year + '/' + (month + 1) + '/' + this.$moment(year + '-' + (month + 1), 'YYYY-MM').daysInMonth()))

      const querySnapshot = await db.collection('invoices')
        .where('dateOfIssue', '>=', starTimes)
        .where('dateOfIssue', '<=', endTimes).get()

      querySnapshot.forEach((doc) => {
        this.purchases.push({
          id: doc.id,
          ...doc.data(),
          dateOfIssue: doc.data().dateOfIssue.toDate()
        })

        // Exchange to PEN
        if (doc.data().currency.code === 'PEN') {
          this.purchasesTotal += doc.data().total
        } else {
          this.purchasesTotal += (doc.data().total * doc.data().exchangeRate)
        }
        // End
      })
    },
    /**
     * Filter by date
     */
    async filterByDate() {
      try {
        if (this.startDate && this.endDate) {

          this.initProgress = true
          await this.resetFilters()
          // Set start date
          this.startDate.setHours(0)
          this.startDate.setMinutes(0)
          // Set end dateU
          this.endDate.setHours(23)
          this.endDate.setMinutes(59)

          const starTimes = Timestamp.fromDate(this.startDate)
          const endTimes = Timestamp.fromDate(this.endDate)
          let querySnapshot = {}

          // Get sales
          querySnapshot = await db.collection('sales')
            .where('createdAt', '>=', starTimes)
            .where('createdAt', '<=', endTimes).get()

          querySnapshot.forEach((doc) => {
            if (doc.data().nubefact.invoice) {
              if (doc.data().nubefact.invoice.tipo_de_comprobante === 1 || doc.data().nubefact.invoice.tipo_de_comprobante === 3) {
                this.sales.push({
                  id: doc.id,
                  ...doc.data(),
                  createdAt: doc.data().createdAt.toDate()
                })

                // Exchange to PEN
                if (doc.data().currency.code === 'PEN') {
                  this.total += doc.data().total
                } else {
                  this.total += (doc.data().total * doc.data().exchangeRate)
                }
                // End

                // Load products
                doc.data().products.forEach((p) => {
                  this.products.push({
                    ...p
                  })
                })

                // Load seller
                const sellerIndex = this.seller.findIndex((s) => s.uid === doc.data().user.uid)
                if (sellerIndex === -1) {
                  this.seller.push({
                    ...doc.data().user,
                    total: (doc.data().currency.code === 'PEN' ? doc.data().total : (doc.data().total * doc.data().exchangeRate))
                  })
                } else {
                  // Exchange to PEN
                  if (doc.data().currency.code === 'PEN') {
                    this.seller[sellerIndex].total += doc.data().total
                  } else {
                    this.seller[sellerIndex].total += (doc.data().total * doc.data().exchangeRate)
                  }
                }
              }
            } else {
              console.log(doc.data())
            }
          })

          this.products.sort((a, b) => {return b.quantity - a.quantity})
          this.seller.sort((a, b) => {return b.total - a.total})

          await this.generateChartsRevenue()
          // End

          // Get purchases
          const querySnapshotPurchases = await db.collection('invoices')
            .where('dateOfIssue', '>=', starTimes)
            .where('dateOfIssue', '<=', endTimes).get()

          querySnapshotPurchases.forEach((doc) => {
            this.purchases.push({
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt.toDate()
            })

            // Exchange to PEN
            if (doc.data().currency.code === 'PEN') {
              this.purchasesTotal += doc.data().total
            } else {
              this.purchasesTotal += (doc.data().total * doc.data().exchangeRate)
            }
            // End
          })
          // End

          // Get credit notes
          const querySnapshotCreditNotes = await db.collection('credits')
            .where('createdAt', '>=', starTimes)
            .where('createdAt', '<=', endTimes).get()

          querySnapshotCreditNotes.forEach((doc) => {
            this.creditNotes.push({
              id: doc.id,
              ...doc.data(),
              createdAt: doc.data().createdAt.toDate()
            })

            // Exchange to PEN
            if (doc.data().currency.code === 'PEN') {
              this.creditNotesTotal += doc.data().total
            } else {
              this.creditNotesTotal += (doc.data().total * doc.data().exchangeRate)
            }
          })
          // End
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Reset filters
     * @returns {Promise<void>}
     */
    resetFilters() {
      try {
        this.total = 0
        this.sales = []
        this.purchasesTotal = 0
        this.purchases = []
        this.products = []
        this.seller = []
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Generate charts renvenue
     */
    generateChartsRevenue() {
      this.$refs.chart1.resetSeries()
      this.revenueGenerated.series = []
      this.revenueGenerated.seriesLine = []
      this.revenueComparisonLine.chartOptions.labels = []
      // Revenue generated
      const serieRevenueGenerated = {}
      serieRevenueGenerated.name = 'Total'
      serieRevenueGenerated.data = []
      const serieRevenueGeneratedLine = {}
      serieRevenueGeneratedLine.name = 'Total'
      serieRevenueGeneratedLine.type = 'column'
      serieRevenueGeneratedLine.data = []
      const reducerRevenue = (accumulator, currentValue) => accumulator + (currentValue.currency.code === 'PEN' ? currentValue.total : (currentValue.total * currentValue.exchangeRate))
      this.revenueGenerated.analyticsData.total = parseFloat(this.sales.reduce(reducerRevenue, 0)).toFixed(2)
      const salesDatesRevenue = []
      this.sales.forEach((p) => {
        let flag = 0
        salesDatesRevenue.forEach((s) => {
          if (this.$moment(p.createdAt).format('YYYY-MM-DD') === s.createdAt) {
            flag = 1
          }
        })
        if (flag === 0) {
          salesDatesRevenue.push({
            createdAt: this.$moment(p.createdAt).format('YYYY-MM-DD'),
            total: 0
          })
        }
      })
      salesDatesRevenue.forEach((s) => {
        this.sales.forEach((p) => {
          if (this.$moment(p.createdAt).format('YYYY-MM-DD') === s.createdAt) {
            s.total += (p.currency.code === 'PEN' ? p.total : (p.total * p.exchangeRate))
          }
        })
      })
      salesDatesRevenue.forEach((s) => {
        serieRevenueGenerated.data.push(s.total.toFixed(2))
        serieRevenueGeneratedLine.data.push(s.total.toFixed(2))
        this.revenueComparisonLine.chartOptions.labels.push(s.createdAt)
      })
      this.revenueGenerated.series.push(serieRevenueGenerated)
      this.revenueGenerated.seriesLine.push(serieRevenueGeneratedLine)
      // End revenue generated
    }
  }
}
</script>
